module.exports = __webpack_public_path__ + "img/replay-button.dba47d3a.png";